/**
 * @module makeActionEndpointRequest
 */

import { getUserMailboxId } from 'owa-client-ids';
import { AUTODISCOVERY_VERSION, AUTODISCOVERY_PROTOCOL } from '../constants';

/**
 * @function
 * To construct the request URL for the autoD API
 * @returns {string} The constructed url string
 */
const getRequestURL = (): string => {
    const mailBoxId: string = getUserMailboxId();
    return `/autodiscover/autodiscover.json/${AUTODISCOVERY_VERSION}/${mailBoxId}?Protocol=${AUTODISCOVERY_PROTOCOL}`;
};

/**
 * @async
 * @function
 * To make a fetch request to get AM action endpoint
 * @returns {Promise<any>} The configuration data
 */
const makeActionEndpointRequest = async (): Promise<any> => {
    try {
        const url: string = getRequestURL();
        const request: Request = new Request(url, {
            method: 'GET',
        });
        const response = await fetch(request);
        if (response.ok) {
            // parse only in case of 2XX response
            // disabling tslint rule as we need to await here
            // for the catch block to work properly
            // https://github.com/palantir/tslint/issues/3933
            // tslint:disable-next-line:no-return-await
            return await response.json();
        } else {
            throw response;
        }
    } catch (error) {
        throw error;
    }
};

export default makeActionEndpointRequest;
